import axios from "../../js/project-axios.js"

const list = productId => {
    return axios.get("/warningSetting/list", {
        params: {
            productId
        }
    });
};

const add = warningSetting => {
    return axios.post("/warningSetting/add", warningSetting);
};

const remove = warningSetting => {
    return axios.post("/warningSetting/remove", warningSetting);
};

export default {
    list,
    add,
    remove
};